// extracted by mini-css-extract-plugin
module.exports = {"base":"InlineEditPopup_base__1tkgd","resetLink":"InlineEditPopup_reset-link__uFWbr"};